export const maxDate = {
  value: 8,
  unit: "months",
} as const;
